var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefiWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9825 0.764465L2.5 7.88511V22.1271L14.9825 29.2486L27.4648 22.1271V7.88511L14.9825 0.764465Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9825 0.764465L2.5 7.88511V22.1271L14.9825 29.2486L27.4648 22.1271V7.88511L14.9825 0.764465ZM10.0541 6.92143H19.8775L21.0619 11.8701H8.91441L10.0541 6.92143ZM12.8845 15.3815L11.8131 12.6176H18.1743L17.1256 15.3815L17.4301 18.4692L14.9825 18.4803H12.5575L12.8845 15.3815ZM16.0092 21.746V20.7655L18.2082 18.6813V15.3926L21.0845 13.5429L24.3667 15.9837L19.8994 23.6746H18.1291L16.0092 21.746ZM5.59901 15.9837L8.89167 13.5651L11.8018 15.3926V18.6813L14.0008 20.7655V21.746L11.8811 23.6969H10.0874L5.59901 15.9837Z",
    fill: "#002D72"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8995 23.6746H18.129L16.0093 21.7459V20.7655L18.2083 18.6813V15.3926L21.0844 13.5428L24.3667 15.9837L19.8995 23.6746ZM14.9824 0.764435V6.92154H19.8775L21.0619 11.8702H14.9824V12.6177H18.1744L17.1256 15.3814L17.43 18.4691L14.9824 18.4803V29.2486L27.4649 22.1272V7.88508L14.9824 0.764435Z",
    fill: "url(#paint0_linear_1013_10520)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.001 21.7459L11.8811 23.6969H10.0874L5.59901 15.9837L8.89181 13.5652L11.802 15.3926V18.6813L14.001 20.7655V21.7459ZM12.5575 18.4803L12.8845 15.3814L11.8133 12.6177H14.9825V11.8702H8.91441L10.0542 6.92154H14.9825V0.764435L2.5 7.88508V22.1272L14.9825 29.2486V18.4803H12.5575Z",
    fill: "url(#paint1_linear_1013_10520)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1013_10520",
    x1: 26.1337,
    y1: 26.1757,
    x2: 26.1337,
    y2: 3.76704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D72",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1013_10520",
    x1: 13.6513,
    y1: 26.1757,
    x2: 13.6513,
    y2: 3.76704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002D72",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiWallet);
export default __webpack_public_path__ + "static/media/defi-wallet.06704e0001873da97147d542cbc6122f.svg";
export { ForwardRef as ReactComponent };